// @ts-nocheck
import React from "react";
import CustomDataTable from "../../../components/CustomDataTable";
import Loader from "../../../components/Loader";
import styles from "./SearchData.module.scss";

export default function SearchTables({
  LoadData,
  isShowData,
  noRetAttend,
  coupWithAttenType,
  retreatsList,
  retreatsColumns,
  retreatColWithCouple,
  coupleColWithRetAttend,
  coupleColWithAttendType,
}: any): JSX.Element {
  if (LoadData) {
    return (
      <div className="text-center py-4">
        <Loader />
      </div>
    );
  }

  let columns = retreatsColumns;
  let pagination = false;
  let tableKey = "tab-1";
  if (isShowData) {
    columns = retreatColWithCouple;
    pagination = true;
    tableKey = "tab-2";
  } else if (noRetAttend) {
    columns = coupleColWithRetAttend;
    pagination = true;
    tableKey = "tab-3";
  } else if (coupWithAttenType) {
    columns = coupleColWithAttendType;
    pagination = true;
    tableKey = "tab-4";
  }

  return (
    <div className={`table-responsive ${styles.tableWrap}`}>
      <CustomDataTable
        key={tableKey}
        data={retreatsList}
        columns={columns}
        pointerOnHover={true}
        highlightOnHover={true}
        pagination={pagination}
      />
      <div id="section-1"></div>
    </div>
  );
}
